import type { PortableTextBlock } from "@portabletext/types";
import Image from "next/image";

import TextBlock from "~/components/TextBlock";

const LandingPageBody = ({ body }: { body: PortableTextBlock[] }) => {
	if (!body) return null;

	return (
		<article className="relative m-auto flex flex-col items-center rounded-lg bg-slate-100 dark:bg-slate-800">
			<div className="absolute mx-auto aspect-square h-full w-full max-w-4xl overflow-hidden">
				<Image
					src={`${process.env.NEXT_PUBLIC_VERCEL_STORAGE_URL}/brookbush-shield-logo-white.png`}
					alt="Brookbush Institute Logo"
					fill
					className="object-cover dark:hidden"
				/>
			</div>

			<TextBlock
				value={body}
				className="z-10 m-auto w-full max-w-6xl px-3 py-12 sm:px-4"
				isArticle
			/>
		</article>
	);
};

export default LandingPageBody;
